export const environment = {
    // PROD (production : true)
    // production: true,
    // endpoint_domain: 'https://phukphan.dmsc.moph.go.th',
    // redirect_domain: 'https://phukphan.dmsc.moph.go.th',
    // mohpromt_url: 'https://moph.id.th',
    // mohpromt_client_id: '9a2162b9-0e4f-45df-9fda-f3dc77a9d184',
    // health_id_url: 'https://moph.id.th',
    // health_id_client_id: '019bbb70-9bf9-7d7f-a580-0a8dcc650102',
    // provider_id_url: 'https://provider.id.th',
    // provider_id_client_id: 'cc323d17-d1f3-479a-90a8-5b63923ad48e',
    // pg_authorization_file: 'Phuk-Phan-Authorization-win32-x64.zip',
    // lab_data_import_master_file: 'LabDataImportMasterFile.xlsx',

    // UAT (production : false)
    // production: false,
    // endpoint_domain: 'https://labs.numedapp.com',
    // redirect_domain: 'https://labs.numedapp.com',
    // mohpromt_url: 'https://uat-moph.id.th',
    // mohpromt_client_id: '98363b20-f00d-48af-b5b5-bf09d4865902',
    // health_id_url: 'https://uat-moph.id.th',
    // health_id_client_id: '019bbb71-5461-7c3a-b42d-ca7f4b974d90',
    // provider_id_url: 'https://uat-provider.id.th',
    // provider_id_client_id: 'dae9a4b1-8101-477b-9216-edc202fe0a5e',
    // pg_authorization_file: 'Phuk-Phan-Authorization-win32-x64.zip',
    // lab_data_import_master_file: 'LabDataImportMasterFile.xlsx',

    //local
    // production: false,
    // endpoint_domain: 'http://localhost:3008',
    // redirect_domain: 'http://localhost:3000',
    // mohpromt_url: 'https://moph.id.th',
    // health_id_url: 'https://uat-moph.id.th',
    // health_id_client_id: '019bbb71-5461-7c3a-b42d-ca7f4b974d90',
    // provider_id_url: 'https://uat-provider.id.th',
    // provider_id_client_id: 'dae9a4b1-8101-477b-9216-edc202fe0a5e',
    // pg_authorization_file: 'Phuk-Phan-Authorization-win32-x64.zip',
    // lab_data_import_master_file: 'LabDataImportMasterFile.xlsx',

    //Devfunction
    production: true,
    endpoint_domain: 'https://dmsc-api.devfunction.com',
    redirect_domain: 'https://dmsc.devfunction.com',
    mohpromt_url: 'https://moph.id.th',
    mohpromt_client_id: '9a2162b9-0e4f-45df-9fda-f3dc77a9d184',
    health_id_url: 'https://uat-moph.id.th',
    health_id_client_id: '019bbb71-5461-7c3a-b42d-ca7f4b974d90',
    provider_id_url: 'https://uat-provider.id.th',
    provider_id_client_id: 'dae9a4b1-8101-477b-9216-edc202fe0a5e',
    pg_authorization_file: 'Phuk-Phan-Authorization-win32-x64.zip',
    lab_data_import_master_file: 'LabDataImportMasterFile.xlsx',
};